import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Case-insensitive membership test for string lists. */
export function includesIgnoreCase(list: string[], candidate: string): boolean {
  const needle = candidate.toLowerCase();
  return list.some(value => value.toLowerCase() === needle);
}
